import { render, staticRenderFns } from "./QnABox.vue?vue&type=template&id=605506f1"
import script from "./QnABox.vue?vue&type=script&lang=js"
export * from "./QnABox.vue?vue&type=script&lang=js"
import style0 from "./QnABox.vue?vue&type=style&index=0&id=605506f1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports